/**
 * PriceRangeFilter — Preis-Spannen-Filter (von/bis) fuer ProductView (F10).
 * Rein praesentational. Leere Eingabe = keine Grenze.
 *
 * Props:
 *   min, max   string             — aktuelle Werte ('' = offen)
 *   onChange   (min, max)=>void    — Callback bei Aenderung
 *   isDarkMode boolean
 *   t          (key)=>string
 */
import React from 'react';
import { Euro, X } from 'lucide-react';

const PriceRangeFilter = ({ min, max, onChange, isDarkMode, t }) => {
  const active = min !== '' || max !== '';
  const inputCls = isDarkMode
    ? 'bg-gray-800/40 border-white/20 text-white placeholder-white/40 focus:ring-blue-400/50'
    : 'bg-white border-slate-200 text-slate-800 placeholder-slate-400 focus:ring-brand/40';

  return (
    <div className="inline-flex items-center gap-2">
      <Euro className={`w-4 h-4 ${isDarkMode ? 'text-white/60' : 'text-slate-400'}`} />
      <span className={`text-sm ${isDarkMode ? 'text-white/70' : 'text-slate-500'}`}>
        {t('products.priceLabel')}
      </span>
      <input
        type="number"
        inputMode="decimal"
        min="0"
        step="0.01"
        value={min}
        onChange={(e) => onChange(e.target.value, max)}
        placeholder={t('products.priceFrom')}
        aria-label={t('products.priceFrom')}
        className={`w-20 px-2 py-1.5 text-sm rounded-lg border focus:ring-2 focus:outline-none transition-colors ${inputCls}`}
      />
      <span className={isDarkMode ? 'text-white/40' : 'text-slate-400'}>–</span>
      <input
        type="number"
        inputMode="decimal"
        min="0"
        step="0.01"
        value={max}
        onChange={(e) => onChange(min, e.target.value)}
        placeholder={t('products.priceTo')}
        aria-label={t('products.priceTo')}
        className={`w-20 px-2 py-1.5 text-sm rounded-lg border focus:ring-2 focus:outline-none transition-colors ${inputCls}`}
      />
      {active && (
        <button
          type="button"
          onClick={() => onChange('', '')}
          aria-label={t('products.filterReset')}
          title={t('products.filterReset')}
          className={`p-1 rounded-md transition-colors ${
            isDarkMode ? 'text-white/50 hover:text-white' : 'text-slate-400 hover:text-slate-700'
          }`}
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default PriceRangeFilter;
